
export default function getSubmitButtonLabel(usersLength: number, teamsLength: number) {

    if (usersLength === 1 && teamsLength < 1) {
        return "Add User & Move"
    }

    if (usersLength < 1 && teamsLength === 1) {
        return "Add Team & Move"
    }

    if (usersLength === 1 && teamsLength > 1) {
        return "Add User, Teams & Move"
    }

    if (usersLength > 1 && teamsLength === 1) {
        return "Add Users, Team & Move"
    }

    if (usersLength > 1 && teamsLength > 1) {
        return "Add Users, Teams & Move"
    }

    return "Add Users, Teams & Move"
}
